import {ListModel, PaginationQueryModel} from "../common";

export enum AssistantVoiceEngineTypeModel {
  V1 = "v1",
  V2 = "v2",
}

// TODO(future): maybe there will be other properties of voice engine
// so keeping this as an object for future.
export type AssistanceVoiceEngineModel = {
  type: AssistantVoiceEngineTypeModel;
};

export enum AssistantVoiceGenderModel {
  MALE = "male",
  FEMALE = "female",
}

export enum AssistantVoiceSynthesizerModel {
  TURBO_V2 = "eleven_turbo_v2",
  TURBO_V2_5 = "eleven_turbo_v2_5",
  FLASH_V2 = "eleven_flash_v2",
  FLASH_V2_5 = "eleven_flash_v2_5",
  MULTILINGUAL_V2 = "eleven_multilingual_v2",
}

export enum AssistantVoiceTabsModel {
  ALL = "all",
  IMPORTED = "imported",
  CLONED = "cloned",
  SHARED = "shared",
}

export enum AssistantVoiceLanguageModel {
  ENGLISH = "en-US",
  PORTUGUESE_BR = "pt-BR",
  SPANISH = "es-ES",
  FRENCH = "fr-FR",
  GERMAN = "de-DE",
  ITALIAN = "it",
  DUTCH = "nl-NL",
  MULTILINGUAL = "multi",
  HINDI = "hi",
  MANDARIN = "zh-CN",
  NORWEGIAN = "no",
  SWEDISH = "sv-SE",
  POLISH = "pl",
  DANISH = "da",
  DANISH_DK = "da-DK",
  CZECH = "cs",
  FINNISH = "fi",
  GREEK = "el",
  HUNGARIAN = "hu",
  INDONESIAN = "id",
  JAPANESE = "ja",
  KOREAN = "ko",
  MALAY = "ms",
  ROMANIAN = "ro",
  RUSSIAN = "ru",
  SLOVAK = "sk",
  THAI = "th",
  TURKISH = "tr",
  UKRAINIAN = "uk",
  VIETNAMESE = "vi",
  BULGARIAN = "bg",
}

export enum AssistantTranscriberProviderModel {
  DEEPGRAM_NOVA_2 = "deepgram",
  DEEPGRAM_NOVA_3 = "deepgram-nova-3",
}

export type AssistantVoiceCompactModel = {
  id: string;
  name: string;
  audioUrl: string | null;
  accent: string;
  engine: AssistanceVoiceEngineModel;
  gender: AssistantVoiceGenderModel;
  isOwner: boolean;
  provider: string;
  synthesizer: AssistantVoiceSynthesizerModel;
};

/* INFO: this model is used in agent record (list item)
for some reason now backend gives out only voice engine type.
*/
export type AssistantVoiceEvenCompactModel = Pick<
  AssistantVoiceCompactModel,
  "engine"
>;

export type AssistantVoiceRecordModel = {
  id: string;
  title: string;
  description: string;
  is_recommended: boolean;
  audioUrl: string;
  language: string;
  gender: string;
  category: string;
  accent: string;
};

export type AssistantVoiceCallListModel = ListModel<AssistantVoiceRecordModel>;

export type AssistantVoiceCallListQueryModel = PaginationQueryModel & {
  voiceCategory: string;
  workspaceId: string;
  accent?: string;
  gender?: AssistantVoiceGenderModel;
  language?: AssistantVoiceLanguageModel;
  search?: string;
};

export enum AssistantWidgetVoiceModel {
  ALLOY = "alloy",
  ECHO = "echo",
  SHIMMER = "shimmer",
}
